import { db } from '@/shared/services/firebase'
import _ from 'lodash'

const fetchContracts = async ({ accountId, type, range }) => new Promise((resolve, reject) => {
  let query = db.collection('contracts')
    .where('accountId', '==', accountId)
  if (type) {
    query = query.where('type', '==', type)
  }
  if (range && range.end) {
    query = query.where('startDate', '<=', range.end)
  }
  query
    .limit(999)
    .get()
    .then(async snapshot => {
      const data = snapshot.docs.map(doc => {
        const item = doc.data()
        item.id = doc.id
        return item
      })
      let filtered = data
      if (range && range.start) {
        filtered = data.filter(el => el.endDate.toDate() > range.start)
      }
      const result = _.orderBy(filtered, 'created', 'desc')
      resolve(result)
    })
    .catch(() => {
      reject()
    })
})

const fetchCampaignList = async type => {
  try {
    let query = db.collection('messages').where('category', '==', type)
    if (type) {
      query = query.where('type', '==', type)
    }
    const snapshot = await query
      .orderBy('published', 'desc')
      .get()

    const messages = snapshot.docs.map(doc => ({...doc.data(), id: doc.id}))
    
    return messages.filter(item => !item.isDraft)
  } catch (error) {
    return Promise.reject(error)
  }
}

const saveContract = ({ id, ...data }) => new Promise((resolve, reject) => {
  if (id) {
    db.collection('contracts')
      .doc(id)
      .update({ ...data }).then(() => {
        resolve()
      })
      .catch(error => {
        reject(error)
      })
  } else {
    db.collection('contracts').add({
      ...data,
    })
      .then(() => {
        resolve()
      })
      .catch(err => {
        reject(err)
      })
  }
})

const getAccount = async id => {
  const user = await db.collection('accounts')
    .doc(id)
    .get()
    .then(doc => ({ ...doc.data(), id: doc.id }))
    .catch(() => null)
  return user
}

const getAnnouncement = async id => {
  const announcement = await db.collection('messages')
    .doc(id)
    .get()
    .then(doc => ({ ...doc.data(), id }))
    .catch(() => null)
  return announcement
}

const deleteContract = id => new Promise((resolve, reject) => {
  db.collection('contracts').doc(id).update({
    status: 'deleted',
  }).then(() => {
    resolve()
  })
    .catch(error => {
      reject(error)
    })
})

const fetchContract = id => new Promise((resolve, reject) => {
  db.collection('contracts')
    .doc(id)
    .get()
    .then(async snapshot => {
      const data = snapshot.data()
      if (data?.accountId) {
        data.account = await getAccount(data.accountId)
      }
      if (data?.announcement && data.announcement.length > 0) {
        data.announcement = await getAnnouncement(data.announcement)
      }
      resolve({ ...data, id })
    })
    .catch(error => {
      reject(error)
    })
})

export {
  fetchContracts,
  fetchCampaignList,
  saveContract,
  fetchContract,
  deleteContract,
  getAnnouncement,
}
